import { useEffect, useRef } from "react";
import { Link } from "react-router";
import { brand } from "../brand.js";

/**
 * Settings → About: the app's name and the credits its data sources require.
 *
 * No TMDB credit (owner, 2026-10-12): titles, artwork, cast and ratings come from the viewer's
 * own provider and from open sources, so About names those. (It carried TMDB's logo and notice
 * from 2026-10-07 while the app used TMDB's API.)
 *
 * Nothing here is a control, so the credit itself is the page's one stop:
 * focus lands on it, wears the ring, and Back leaves as from any page.
 */
/**
 * Open's sources (Section 26; ADR "Home rows and title pages from open data"): what each is
 * used for and its licence, and the way to every cast photo's own credit.
 */
function OpenCredits({ creditRef }: { creditRef: React.RefObject<HTMLDivElement | null> }) {
  return (
    <div ref={creditRef} className="about-credit" tabIndex={0} role="group" aria-label="Credits">
      <h2 className="settings-card-title">Credits</h2>
      <p className="settings-row-hint">
        Titles, artwork, descriptions, cast and ratings come from your provider. Titles, genres,
        directors and cast: Wikidata (CC0). Trending and Popular: Wikipedia page views (Wikimedia
        Foundation). Box-office number ones: Wikipedia (CC BY-SA). TV schedules and show pictures:
        TVmaze (CC BY-SA). Cast photos: Wikimedia Commons, each under its own licence and credited
        by name.
      </p>
      <Link className="ui-btn about-credit__link" to="/settings/about/images">Image credits</Link>
    </div>
  );
}

export function AboutPage() {
  const creditRef = useRef<HTMLDivElement>(null);
  useEffect(() => creditRef.current?.focus(), []);
  return (
    <div className="page page--about">
      <div className="settings-card">
        <div className="settings-header">
          <img className="settings-logo" src={brand().icon} alt="" />
          <h1 className="settings-title">About {brand().appName}</h1>
        </div>
        <OpenCredits creditRef={creditRef} />
      </div>
    </div>
  );
}
